const MIN_DURATION_SECONDS = 1.5;
const MAX_DURATION_SECONDS = 4;
const SECONDS_PER_KILOMETER = 3;
const METERS_PER_KILOMETER = 1_000;

/**
 * Drawing time grows with the length of the drive. Short drives still get a visible animation and
 * long drives do not keep the user waiting.
 */
export const getRouteAnimationDuration = (distanceMeters: number) =>
  Math.min(
    MAX_DURATION_SECONDS,
    Math.max(MIN_DURATION_SECONDS, (distanceMeters / METERS_PER_KILOMETER) * SECONDS_PER_KILOMETER)
  );
